import * as React from "react";
import type { SVGProps } from "react";
const SvgIvr = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M18.763 15.401a2.437 2.437 0 1 0 0 4.875 2.437 2.437 0 0 0 0-4.875Zm0 0v-1.88c0-.698-.565-1.263-1.263-1.263h-5.416M5.152 15.4v-1.88c0-.698.566-1.263 1.264-1.263h5.668m0 0V9.5m0 2.757V15.4m7.045-11.348c.157.157.284.354.367.585.083.232.135.477.148.743.022.45-.043.857-.2 1.232q-.228.56-.687 1.018c-.445.446-1.026.818-1.743 1.106q-1.076.433-2.368.638c-.87.135-1.752.205-2.657.21a17.6 17.6 0 0 1-2.648-.21c-.856-.14-1.643-.35-2.346-.634Q5.933 8.31 5.25 7.627a3.2 3.2 0 0 1-.686-1 2.84 2.84 0 0 1-.227-1.233c.005-.555.175-.996.498-1.32.123-.122.271-.218.433-.275.166-.06.345-.083.537-.048l2.443.415c.188.031.345.075.48.132a1 1 0 0 1 .328.205q.159.158.219.402c.043.157.065.345.065.555l.013.677a.33.33 0 0 0 .105.245.6.6 0 0 0 .114.087c.048.022.087.035.122.053q.335.099.966.153c.424.03.865.052 1.324.056.467-.004.909-.017 1.337-.052.42-.035.738-.092.966-.162q.047-.019.113-.043a.4.4 0 0 0 .127-.092.34.34 0 0 0 .105-.254l.004-.66q-.001-.328.07-.559a.82.82 0 0 1 .218-.402 1 1 0 0 1 .324-.21q.201-.083.476-.135l2.473-.42a.94.94 0 0 1 .52.04c.153.066.288.149.41.27ZM7.559 17.457a2.437 2.437 0 1 1-4.814.763 2.437 2.437 0 0 1 4.815-.763Zm6.836.382a2.437 2.437 0 1 1-4.874 0 2.437 2.437 0 0 1 4.874 0Z"
    />
  </svg>
);
export default SvgIvr;
